(() => {
  angular
    .module('app.components')
    .factory('ChartService', ChartService);

  function ChartService() {
    const grayColors = [
    ];

    let baseColors = [
      '#17D6D8',
      '#9EE010',
      ...grayColors,
    ];

    let pieColors = [
      '#17D6D8',
      '#13ABAC',
      '#0E7F81',
      '#145D5D',
      '#9EE010',
      '#7EB30D',
      '#5E860A',
      '#3F5906',
      '#4f5a5a',
      '#8a9c9c',
    ];

    // if we are exporting report, getting company colors
    if ($('body').hasClass('pdf-export')) {
      const primaryColor = $('#primaryColor').css('color');
      const primaryColorTint25 = $('#primaryColorTint25').css('color');
      const primaryColorShade25 = $('#primaryColorShade25').css('color');
      const primaryColorShade60 = $('#primaryColorShade60').css('color');

      const secondaryColor = $('#secondaryColor').css('color');
      const secondaryTint25 = $('#secondaryTint25').css('color');
      const secondaryShade25 = $('#secondaryShade25').css('color');
      const secondaryShade60 = $('#secondaryShade60').css('color');

      baseColors = [
        primaryColor,
        secondaryColor,
        ...grayColors,
      ];

      pieColors = [
        primaryColorTint25,
        primaryColor,
        primaryColorShade25,
        primaryColorShade60,
        secondaryTint25,
        secondaryColor,
        secondaryShade25,
        secondaryShade60,
      ];
    }

    const baseConfig = () => ({
      title: '',
      colors: baseColors,
      chart: {
        type: 'areaspline',
        style: {
          fontFamily: 'Helvetica',
          fontSize: '11px'
        },
        spacingTop: 45,
        marginRight: 5
      },

      legend: {
        enabled: true,
        layout: 'horizontal',
        align: 'center',
        verticalAlign: 'top',
        y: -50,
        floating: true,
        itemDistance: 20,
        borderWidth: 0,
        backgroundColor: '#FFFFFF',
        itemStyle: {
          color: '#889696',
          fontSize: '12px',
          fontWeight: 'normal'
        },
        symbolHeight: 8,
        symbolWidth: 8,
        symbolRadius: 5,
        symbolPadding: 10
      },

      xAxis: {
        allowDecimals: false,
        gridLineColor: '#ededed',
        gridLineWidth: 1,
        minPadding: 0,
        maxPadding: 0,
        tickWidth: 0,
        lineWidth: 0,
        type: 'linear',
        labels: {
          y: 20,
          style: {
            color: '#96a6a6'
          }
        }
      },

      yAxis: {
        title: '',
        gridLineColor: '#ededed',
        showFirstLabel: false,
        labels: {
          x: -15,
          style: {
            color: '#96a6a6'
          }
        }
      },

      tooltip: {
        shared: true,
        useHTML: true,
        borderRadius: 2,
        borderWidth: 0,
        borderColor: '#d4d4d4',
        backgroundColor: 'transparent',
        shadow: false,
        valueDecimals: 2,
        style: {
          color: '#96a6a6',
          fontSize: '12px',
          padding: 0
        },
        crosshairs: {
          width: 1,
          color: '#5c6767'
        }
      },

      credits: {
        enabled: false
      },

      plotOptions: {
        areaspline: {
          animation: !$('body').hasClass('pdf-export'),
          fillOpacity: 0.1,
          lineWidth: 3,
          marker: {
            lineWidth: 3,
            symbol: 'circle',
            radius: 5
          }
        }
      },
    });

    const pieConfig = () => ({
      options: {
        colors: pieColors,
        chart: {
          type: 'pie',
          height: 340,
        },
        title: {
          text: '',
        },
        tooltip: {
          enabled: false,
        },
        plotOptions: {
          animation: !$('body').hasClass('pdf-export'),
          allowPointSelect: true,
          pie: {
            size: 200,
            innerSize: 100,
            center: ['50%', '50%'],
            allowPointSelect: true,
            dataLabels: {
              useHTML: true,
              formatter: function() {
                return `
                  <b>${this.point.name}</b>
                  <span class="light">: ${this.y}%</span>`;
              },
            },
          },
        },
      },
    });

    return {
      getBaseChartConfig: () => baseConfig(),
      getPieChartConfig: () => pieConfig(),
    }
  }
})();
